import { render } from "./PredictionEventDetail.vue?vue&type=template&id=61113c21&scoped=true"
import script from "./PredictionEventDetail.vue?vue&type=script&lang=js"
export * from "./PredictionEventDetail.vue?vue&type=script&lang=js"

import "./PredictionEventDetail.vue?vue&type=style&index=0&id=61113c21&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61113c21"],['__file',"resources/js/components/PredictionEventDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61113c21"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61113c21', __exports__)) {
    api.reload('61113c21', __exports__)
  }
  
  module.hot.accept("./PredictionEventDetail.vue?vue&type=template&id=61113c21&scoped=true", () => {
    api.rerender('61113c21', render)
  })

}


export default __exports__